(function () {
  function initTheCoFilter() {
    var root = document.getElementById('TheCoFilter');
    if (!root || root.getAttribute('data-bound') === 'true') return;
    root.setAttribute('data-bound', 'true');

    var toggle = root.querySelector('[data-co-filter-toggle]');
    var menu = root.querySelector('[data-co-filter-menu]');
    var label = root.querySelector('[data-co-filter-label]');
    var arrow = root.querySelector('[data-dropdown-arrow]');
    if (!toggle || !menu || !label) return;

    function setOpen(open) {
      menu.classList.toggle('is-show', open);
      if (arrow) arrow.classList.toggle('active', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function panels() {
      return document.querySelectorAll('[data-co-panel]');
    }

    toggle.addEventListener('click', function () {
      setOpen(!menu.classList.contains('is-show'));
    });

    toggle.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });

    menu.addEventListener('click', function (event) {
      var item = event.target.closest('[data-co-value]');
      if (!item) return;
      applyFilter(item);
    });

    menu.addEventListener('keydown', function (event) {
      var item = event.target.closest('[data-co-value]');
      if (!item) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        applyFilter(item);
      }
      if (event.key === 'Escape') setOpen(false);
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) setOpen(false);
    });

    function applyFilter(item) {
      var value = item.getAttribute('data-co-value');
      var text = item.querySelector('.text');
      if (text) label.textContent = text.textContent;
      menu.querySelectorAll('[data-co-value]').forEach(function (entry) {
        entry.classList.toggle('is-active', entry === item);
      });
      panels().forEach(function (panel) {
        var show = value === 'all' || panel.getAttribute('data-co-panel') === value;
        panel.classList.toggle('is-hidden', !show);
      });
      setOpen(false);
      if (value !== 'all') {
        var target = document.querySelector('[data-co-panel="' + value + '"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTheCoFilter);
  } else {
    initTheCoFilter();
  }
})();
